import React from 'react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import clientConfig from '../../../../client-config';

const PostImage = ({ imageData }) => {
  return (
    <Img
      key={Math.random().toString(32).substring(7)}
      className="blog-Image-wrapper"
      fluid={getFluidGatsbyImage(imageData?.asset?._ref, { maxWidth: 675 }, clientConfig.sanity)}
      alt=""
    />
  );
};

export default PostImage;
